import(/* webpackMode: "eager" */ "/home/saif-dc/DC/projects/react-node-js/ucb/app/layout.jsx");
